import { render, staticRenderFns } from "./science.vue?vue&type=template&id=43cf4c66&scoped=true"
import script from "./science.vue?vue&type=script&lang=js"
export * from "./science.vue?vue&type=script&lang=js"
import style0 from "./science.vue?vue&type=style&index=0&id=43cf4c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf4c66",
  null
  
)

export default component.exports